export const SESSION_EXPIRED_MESSAGE = 'Your session expired. Please sign in again.';

const SESSION_EXPIRED_NOTICE_KEY = 'agents.sessionExpiredNotice';

/** Mark that the user should see a session-expired message on the login screen. */
export function markSessionExpiredNotice(): void {
  sessionStorage.setItem(SESSION_EXPIRED_NOTICE_KEY, '1');
}

/**
 * Read and clear the session-expired notice flag (once per redirect).
 * @returns {boolean}
 */
export function consumeSessionExpiredNotice(): boolean {
  const value = sessionStorage.getItem(SESSION_EXPIRED_NOTICE_KEY);
  if (!value) {
    return false;
  }

  sessionStorage.removeItem(SESSION_EXPIRED_NOTICE_KEY);
  return true;
}
